import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

export interface TabType {
  name: string;
  url?: string;
  queryParams?: { [key: string]: any };
}

@Injectable()
export class PsTabSessionService {
  constructor(private router: Router) {}
  tabs: TabType[] = [];

  private tabsSubject = new BehaviorSubject<TabType[]>(this.tabs);
  tabs$: Observable<TabType[]> = this.tabsSubject.asObservable();

  addTab(tab: TabType) {
    const markDetatchRouterRecursive = (tabType: TabType, routers: Route[]) => {
      routers.map((route: Route) => {
        if (route.children) {
          markDetatchRouterRecursive(tabType, route.children);
        }
        if (route.path === tabType.url.replace('/session/', '')) {
          route.data = { ...route.data, detatchRoute: true };
        }
      });
    };

    markDetatchRouterRecursive(
      tab,
      this.router.config.filter((route: Route) => route.path === 'session')
    );

    if (
      this.tabs.findIndex((tabItem: TabType) => tab.url === tabItem.url) < 0
    ) {
      this.tabs.push(tab);
    }
  }
}
